// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"3eb8beb1","268":"4ebe9bf7","282":"9dc86a39","601":"96073cf8","778":"645d433e"}[chunkId] + ".chunk.js";
};